import api from '@/api'

export default {
  namespaced: true,
  state: {
    brands: [],
    fetching: false
  },
  actions: {
    async fetchBrands ({ state, commit, getters }, { identifier, type }) {
      commit('fetching')

      return api[identifier].getBrands()
        .then(brands => commit('setFetchData', brands))
        .catch(() => commit('setFetchData', []))
    }
  },
  mutations: {
    setFetchData (state, brands) {
      state.brands = brands
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/marketplaceBrands.js